import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-email",
  "use": "channel-email-usage",
  "viewBox": "0 0 24 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 17\" id=\"channel-email\"><path d=\"M22.161 1.3l-8.144 6.264a3.308 3.308 0 01-4.034 0L1.839 1.3M3 15.75h18a1.5 1.5 0 001.5-1.5v-12A1.5 1.5 0 0021 .75H3a1.5 1.5 0 00-1.5 1.5v12a1.5 1.5 0 001.5 1.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-email.svg
// module id = B3k2
// module chunks = 38 43